import { Modal, message } from 'antd';
import React, { Component } from 'react'
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

export default class BigAccount extends Component {

    state = {
        params: {},
        visible: false,
    }

    show = (record) => {
        const { keyAccountManagerName } = record;
        this.setState({
            params: {
                ...record,
                keyAccountManagerName: keyAccountManagerName == null ? undefined : keyAccountManagerName,
            },
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params } = this.state;
        const { customerCompanyId, keyAccountManagerId } = params;
        Fetch.post(API_URL.contract.setCustomerCompanyKeyAccountManager, {
            customerCompanyId,
            keyAccountManagerId,
        }).then((res) => {
            message.success(res.success);
            this.hide();
            this.props.loadData();
        }).catch(err => {
            console.error(err);
        });
    }

    handleChange = (option, key) => {
        const { params } = this.state;
        params[`${key}Name`] = option.text;
        params[`${key}Id`] = option.value;
        this.setState({ params });
    }

    render() {
        const { params, visible } = this.state;
        const { keyAccountManagerName } = params;
        return (
            <Modal
                title={`配置大客户经理`}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                width="550px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">配置大客户经理:</div>
                            <div className="item-right">
                                <SearchRetrieve
                                    keyword='keyWord'
                                    style={{ width: 180 }}
                                    placeholder="输入姓名/工号检索"
                                    value={keyAccountManagerName}
                                    params={{ limit: 20, needPosition: 'TRUE' }}
                                    url={API_URL.execute.queryEmpListByRoleCode}
                                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                    onChange={option => this.handleChange(option, 'keyAccountManager')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/BigAccount.js